// Centralized app configuration
// Use Vite env vars for client-side config. Prefix with VITE_ in your .env files.

export const API_BASE_URL: string =
  import.meta.env.VITE_API_BASE_URL || "http://localhost:8001";

// Static project id to use for chat history/session APIs
export const PROJECT_ID: string = import.meta.env.VITE_PROJECT_ID || "";

// Optional separate base URL for prompt enhancement service
export const ENHANCE_API_BASE_URL: string =
  import.meta.env.VITE_ENHANCE_API_BASE_URL || "https://your-production-domain.com";

// Azure AD API scope for backend authentication
export const API_SCOPE: string =
  import.meta.env.VITE_API_SCOPE || "User.Read";
